(function () {
  'use strict';

  /* Left/right arrow keys step through the product gallery.

     Driven through the thumbnail buttons rather than the slider's own
     prev/next controls: the thumbnails are the single source of truth for
     which media is active (Dawn marks the current one with aria-current), and
     clicking one runs the theme's existing setActiveMedia -- so this works
     identically on the desktop thumbnail layout and the mobile carousel
     without duplicating any of that logic. */

  var gallery = document.querySelector('media-gallery');
  if (!gallery) return;

  function thumbs() {
    return Array.prototype.slice.call(gallery.querySelectorAll('.thumbnail-list__item .thumbnail'));
  }

  function activeIndex(list) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].getAttribute('aria-current') === 'true') return i;
    }
    return -1;
  }

  /* Don't hijack the arrows while someone is typing, using a select, or
     moving the caret in a quantity field. */
  function isTyping(el) {
    if (!el) return false;
    if (el.isContentEditable) return true;
    var tag = el.tagName;
    return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT';
  }

  function galleryInView() {
    var r = gallery.getBoundingClientRect();
    var h = window.innerHeight || document.documentElement.clientHeight;
    return r.bottom > 0 && r.top < h;
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    if (event.metaKey || event.ctrlKey || event.altKey) return;
    if (isTyping(document.activeElement)) return;
    if (!galleryInView()) return;

    var list = thumbs();
    if (list.length < 2) return;

    var current = activeIndex(list);
    if (current === -1) current = 0;

    var next = event.key === 'ArrowRight' ? current + 1 : current - 1;
    if (next < 0 || next >= list.length) return; /* stop at the ends, don't wrap */

    event.preventDefault();
    list[next].click();

    /* Keep the newly selected thumbnail inside the visible strip. */
    if (list[next].scrollIntoView) {
      list[next].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
  });
})();
